<template>
<div class="chapter">
<div class="inner_page">
<div class="chap" id="prologue">
<p class="ct"><a class="xref" href="#/pppclubbeddeath005#toc">Prologue</a></p>
<p class="pf">‘Are you still out of work, Robert?’</p>
<p>‘Yes I am,’ said Amiss blackly. ‘Things aren’t looking up.’</p>
<p>‘Oh good,’ said Ellis Pooley. And then, hastily recollecting himself, ‘Sorry, Robert. Of course I didn’t mean that. I just meant, oh good, that means you’re likely to be free for lunch today.’</p>
<p>‘Are you sure that’s all you mean? You wouldn’t by any chance be coming up with job suggestions for me again, would you?’</p>
<p>‘Don’t be so suspicious, Robert,’ said Pooley firmly. ‘A friend should be able to ask you to lunch without his motives being impugned.’</p>
<p>Amiss snorted. ‘Not when that friend is Sergeant Pooley of the CID. However, if you’re paying, yes, I am free for lunch today. When and where?’</p>
<p>‘One o’clock at the Repeal Club.’</p>
<p>‘The Repeal Club? Blimey! What’s a nice young policeperson doing in a place like that?’</p>
<p>‘There’s nothing wrong with the Repeal Club.’ Pooley sounded slightly offended. ‘My father put me up for it when I came down from Cambridge. It’s really terribly economical and convenient. Of course if you’d prefer me to invite you to the snack bar in the police canteen…?’</p>
<p>‘No, no,’ said Amiss hastily. ‘Incidentally, what’s it trying to repeal?’</p>
<p>‘The Corn Laws.’</p>
<p>‘Weren’t they repealed in the mid-nineteenth century?’</p>
<p>‘Indeed they were.’ Pooley’s patience seemed to be wearing thin. ‘However, we’re still celebrating. Now, Robert, I’ll see you at lunch-time. Oh, and please wear a jacket and tie.’</p>
<p>‘Where is this place anyway?’</p>
<p>‘At the Regent Street end of Pall Mall opposite the Travellers’ and the Reform. See you.’ Pooley put the phone down firmly.</p>
<p>Thankfully abandoning the application forms he had been filling in half-heartedly, Amiss wandered into his bedroom to begin the process of changing himself into something resembling a gentleman. He felt cheered by this break in his demoralising daily routine. A momentary fear struck him that Pooley might be in the austere mood that characterised so many people at lunch-times in these puritanical days. Would it be the cheerless litre of mineral water and grudging offer of a single glass of wine? He shook the notion off as unworthy. Gentlemen didn’t behave like that—especially when entertaining the indigent.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// pppclubbeddeath007.vue?a8d770ca